import { render, staticRenderFns } from "./SumupResultRankListCurriculum.vue?vue&type=template&id=fb2a3f48&scoped=true&"
import script from "./SumupResultRankListCurriculum.vue?vue&type=script&lang=ts&"
export * from "./SumupResultRankListCurriculum.vue?vue&type=script&lang=ts&"
import style0 from "./SumupResultRankListCurriculum.vue?vue&type=style&index=0&id=fb2a3f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2a3f48",
  null
  
)

export default component.exports